import { connect } from 'react-redux';

import AuctionsMerchantSummary from 'components/auctions/AuctionsMerchantSummary';
import { fetchMerchantAuctionsSummary } from 'data/auctions/Auctions.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      data: state.auctions.merchantSummaryData,
      partyType: state.app.lookups.partyTypes.find(
        p => p.ID === state.app.user.PartyType
      ),
    },
    state,
    'regions'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchMerchantAuctionsSummary: () =>
      dispatch(fetchMerchantAuctionsSummary()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuctionsMerchantSummary);
